export default "__VITE_ASSET__6b6448af__"